// ===========================================
// Lessons Page Constants
// ===========================================

import { LessonFormData } from './lessons.types';
import { MAX_TERM_WEEKS } from '../../../utils/dateUtils';

export const DAYS_OF_WEEK = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

export const DEFAULT_FORM_DATA: LessonFormData = {
  name: '',
  description: '',
  lessonTypeId: '',
  termId: '',
  termIds: [],
  teacherId: '',
  locationId: '',
  roomId: '',
  instrumentId: '',
  programLevelId: '',
  streamId: '',
  hasSchedule: true,
  dayOfWeek: 1, // Monday default
  startTime: '09:00',
  durationMins: 45,
  maxStudents: 1,
  isRecurring: true,
  isActive: true,
  // Hybrid pattern
  patternType: 'ALTERNATING',
  hybridCombination: 'GROUP_INDIVIDUAL',
  groupWeeks: [],
  individualWeeks: [],
  bandLessonId: '',
  bandWeeks: [],
  individualSlotDuration: 30,
  bookingDeadlineHours: 24,
  // Band term
  classWeeksPatternType: 'EVERY_WEEK',
  classWeeks: [],
  // Partner classes
  partnerLessonId: '',
  // Mid-term window (null = full term)
  startWeek: null,
  endWeek: null,
};

// Week numbers 1..MAX_TERM_WEEKS for hybrid pattern selection — the transport
// ceiling, not a term bound. Phase E bounds the picker by the selected term.
export const WEEK_NUMBERS = Array.from({ length: MAX_TERM_WEEKS }, (_, i) => i + 1);
